import { render, staticRenderFns } from "./tord_examine.vue?vue&type=template&id=10fda846&scoped=true&"
import script from "./tord_examine.vue?vue&type=script&lang=js&"
export * from "./tord_examine.vue?vue&type=script&lang=js&"
import style0 from "./tord_examine.vue?vue&type=style&index=0&id=10fda846&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10fda846",
  null
  
)

export default component.exports